// export const baseUrl = "http://192.168.1.20:7000/api/v1";
// export const baseUrl = "https://installmentworld-backend.onrender.com/api/v1";
export const baseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://installmentworld-backend-snsi.onrender.com/api/v1";
